@if (label) {
  <p-floatLabel [variant]="floatLabelVariant">
    <bs-autocomplete
      bsFloatLabelCompat
      inputId="sectorDropdown"
      [ngModel]="selectedSector"
      (ngModelChange)="selectedSector = $event"
      [items]="options()"
      [dropdown]="true"
      [requireSelection]="true"
      [disabled]="disabled"
      [minLength]="0"
      (queryChange)="onQueryChange($event)"
      (selected)="onSelect()"
      (cleared)="onClear()"
      (blurred)="onBlur()" data-testid="selected-sector-autocomplete">
    </bs-autocomplete>
    <label for="sectorDropdown">{{ label }}</label>
  </p-floatLabel>
} @else {
  <bs-autocomplete
    inputId="sectorDropdown"
    [ngModel]="selectedSector"
    (ngModelChange)="selectedSector = $event"
    [items]="options()"
    [dropdown]="true"
    [requireSelection]="true"
    [disabled]="disabled"
    [minLength]="0"
    (queryChange)="onQueryChange($event)"
    (selected)="onSelect()"
    (cleared)="onClear()"
    (blurred)="onBlur()" data-testid="selected-sector-autocomplete-2">
  </bs-autocomplete>
}


